import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'classDistributer'
})
export class ClassDistributerPipe implements PipeTransform {

  transform(classes: string[]): any {
    if (classes.length === 0) {
      return '';
    }
    classes = classes.map(c => c.replace(/"/g, ''));
    const classList = classes.join(' ');
    return classList;
  }

}
